import React from "react";
import Grid from "@mui/material/Grid";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import images from "@app/images";
// import { CounterContext } from "../../../../App";

const MainDrawerLogo = ({ onHome = null }) => {
  // const counterContext = useContext(CounterContext);
  return (
    <Grid sx={{ mt: 3, pl: 2.5 }}>
      <Grid
        container
        direction="row"
        alignItems="center"
        sx={{ mb: 13.125, cursor: "pointer" }}
        onClick={onHome}
      >
        <Avatar
          alt="열나요 로고"
          src={images.site_logo.default}
          sx={{ width: 40, height: 40 }}
        />
        <Grid sx={{ ml: 1.5 }}>
          <img
            alt="열나요 명칭"
            src={images.logo_title.default}
            sx={{ width: 46, height: 15 }}
          />
          <Typography
            variant="body2"
            fontWeight={500}
            sx={{ color: "#A1A1A1" }}
          >
            광고 관리자 페이지
            {/* <button onClick={() => counterContext.countDispacth("increment")}>
              +
            </button> */}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MainDrawerLogo;
